import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";


const Examinations = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const menu = [
        { name: "Notices & Circulars", path: "notices" },
        { name: "Exam Timetable", path: "exam-timetable" },
    ];

    const activeItem =
        menu.find((m) => location.pathname.includes(m.path))?.name || "About MANET";

    // Mapping for title + background based on route
    const bannerDataMap = {
        "notices": {
            title: "Notices & Circulars",
            bgImage: "/assets/images/inner_bnr/pexels.jpg",
        },
        "exam-timetable": {
            title: "Exam Timetable",
            bgImage: "/assets/images/inner_bnr/pexels.jpg",
        },

    };

    // Reusable function to fetch matching banner data
    const getBannerData = () => {
        const matchedKey = Object.keys(bannerDataMap).find((key) =>
            location.pathname.includes(key)
        );

        // If no match found → default to About MANET
        return (
            bannerDataMap[matchedKey] || {
                title: "About MANET",
                bgImage: "/assets/images/inner_bnr/pexels.jpg",
            }
        );
    };

    const { title, bgImage } = getBannerData();

    const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

    return (
        <>
            <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

            <div className="page-layout">
                <Sidebar menuItems={menu} />

                <div className="page-content">
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default Examinations;
